import { SVGProps, Ref, forwardRef } from 'react'
const SvgColorInstagram = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1.5rem"
    height="1.5rem"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      fill="url(#ColorInstagram_svg__a)"
      fillRule="evenodd"
      d="M2.843 2.843a5.383 5.383 0 0 1 1.946-1.267c.696-.273 1.495-.46 2.668-.51C8.627 1.014 9.001 1 11.982 1c2.981 0 3.356.013 4.525.067 1.17.053 1.968.236 2.664.509a5.382 5.382 0 0 1 1.946 1.267 5.412 5.412 0 0 1 1.263 1.941c.268.696.455 1.495.508 2.664.054 1.17.067 1.544.067 4.525 0 2.981-.013 3.356-.067 4.525-.053 1.17-.236 1.968-.508 2.664a5.383 5.383 0 0 1-1.268 1.946 5.383 5.383 0 0 1-1.945 1.267c-.696.268-1.495.455-2.664.509-1.17.053-1.544.067-4.525.067-2.981 0-3.356-.014-4.525-.067-1.17-.054-1.968-.236-2.664-.509a5.383 5.383 0 0 1-1.946-1.267 5.382 5.382 0 0 1-1.267-1.946c-.268-.696-.456-1.495-.51-2.664C1.014 15.33 1 14.954 1 11.973c0-2.98.013-3.356.067-4.525.053-1.169.236-1.968.509-2.664a5.367 5.367 0 0 1 1.267-1.941Zm15.61.576c-.389-.152-.969-.33-2.04-.38-1.156-.053-1.504-.062-4.436-.062-2.931 0-3.28.009-4.435.062-1.071.05-1.651.228-2.04.38-.513.2-.879.437-1.263.82a3.42 3.42 0 0 0-.82 1.264c-.152.388-.33.968-.38 2.039-.05 1.156-.062 1.504-.062 4.436 0 2.931.008 3.28.062 4.435.05 1.071.228 1.651.38 2.04.2.513.437.879.82 1.263.384.383.75.62 1.263.82.389.152.969.33 2.04.38 1.155.05 1.504.063 4.435.063 2.932 0 3.28-.01 4.436-.063 1.071-.05 1.651-.228 2.04-.38.513-.2.878-.437 1.262-.82.384-.384.62-.75.821-1.263.152-.389.33-.969.38-2.04.049-1.155.062-1.504.062-4.435 0-2.932-.009-3.28-.062-4.436-.05-1.071-.228-1.651-.38-2.04-.2-.513-.437-.878-.82-1.262a3.42 3.42 0 0 0-1.264-.821Z"
      clipRule="evenodd"
    />
    <path
      fill="url(#ColorInstagram_svg__b)"
      fillRule="evenodd"
      d="M11.978 17.614a5.636 5.636 0 1 1 0-11.273 5.636 5.636 0 0 1 0 11.273Zm0-1.977a3.658 3.658 0 1 0 0-7.319 3.659 3.659 0 1 0 0 7.319Z"
      clipRule="evenodd"
    />
    <circle cx={17.842} cy={6.118} r={1.316} fill="#654C9F" />
    <defs>
      <radialGradient
        id="ColorInstagram_svg__b"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="rotate(-3 319.848 -116.702) scale(16.3001)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FED576" />
        <stop offset={0.263} stopColor="#F47133" />
        <stop offset={0.609} stopColor="#BC3081" />
        <stop offset={1} stopColor="#4C63D2" />
      </radialGradient>
      <linearGradient
        id="ColorInstagram_svg__a"
        x1={-3}
        x2={32}
        y1={23}
        y2={11.999}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FED576" />
        <stop offset={0.263} stopColor="#F47133" />
        <stop offset={0.609} stopColor="#BC3081" />
        <stop offset={1} stopColor="#4C63D2" />
      </linearGradient>
    </defs>
  </svg>
)
const ForwardRef = forwardRef(SvgColorInstagram)
export default ForwardRef
